var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeFillV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86 1.25C4.66201 1.25 1.9375 3.7595 1.9375 7.01872C1.9375 9.26711 2.9407 11.16 4.27026 12.7281C5.59526 14.2908 7.30472 15.6024 8.85012 16.7003L11.5165 18.5944C11.8085 18.8019 12.1915 18.8019 12.4835 18.5944L15.1499 16.7003C16.6953 15.6024 18.4047 14.2908 19.7297 12.7281C21.0593 11.16 22.0625 9.26711 22.0625 7.01872C22.0625 3.7595 19.338 1.25 16.14 1.25C14.4915 1.25 13.0409 2.0612 12 3.11083C10.9591 2.0612 9.50849 1.25 7.86 1.25Z",
    fill: "#D73A49",
    stroke: "#D73A49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFillV2);
export default __webpack_public_path__ + "static/media/like_fill_v2.4a51a2bee899ba558c8e3f57aa3a6204.svg";
export { ForwardRef as ReactComponent };